import axios from '../../functions/axios';
import { useReducer } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './Clients.module.css';

function AddClient() {
  const formReducer = (state, event) => {
    if (event.reset) {
      return {
        companyName: '',
        phoneNumber: '',
        clientData: '',
        timocomID: '',
      };
    }
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {});
  const location = useLocation();
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    await axios.post(`/client`, formData);
    navigate(location.state?.from || '/clientsList');
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h2 className={style.category}>Dodaj Klienta</h2>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='companyName-data'>Nazwa klienta:</label>
            <input type='text' placeholder='Nazwa klienta' name='companyName' onChange={handleChange} value={formData.companyName || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='number-data'>Nr telefonu:</label>
            <input type='text' placeholder='Telefon' name='phoneNumber' onChange={handleChange} value={formData.phoneNumber || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='timocom-data'>
              TIMOCOM ID:
            </label>
            <input id='timocom-data' name='timocomID' type='text' onChange={handleChange} value={formData.timocomID || ''} />
          </div>
          <hr />
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='paletts'>Saldo palet?</label>
          <input id='paletts' type='checkbox' name='paletts' onChange={handleChange} checked={formData?.paletts || '' } />
        </div>
        <hr />
          <div className={style.category}>Dane klienta</div>
          <div className={style.row}>
            <textarea className={style.textData} id='client-data' name='clientData' onChange={handleChange} value={formData.clientData || ''} />
          </div>
          <hr />
          <span className={style.buttons}>
            <button className='btn btn-default' onClick={navigate.bind(null, location.state?.from || '/clientsList', { state: { date: formData.day } })}>Anuluj</button>
            <button className='btn btn-default' type='submit'>Dodaj klienta</button>
          </span>
        </div>
      </form>
    </div>
  );
}

export default AddClient;